import ReactDOM from 'react-dom';
import preloaded from '../../src/preloaded';

import DownloadMediaBtn from '../../src/media/DownloadMediaBtn.jsx';

let domDeleteEl = document.querySelectorAll('.DownloadBtn');
let media;
if (preloaded.video) media = preloaded.video;
if (preloaded.picture) media = preloaded.picture;

if (domDeleteEl) {
  domDeleteEl.forEach( el => {
    ReactDOM.render(<DownloadMediaBtn media={media} el={el} />, el);
  });
}